"use client";

import { FC, useState, useEffect } from "react";
import { Button } from "antd-mobile";
import { SystemQRcodeOutline } from "antd-mobile-icons";
import Image from "next/image";
import cs from "@/utils/classNames";
import ExclusiveEarningMask from "@/components/ExclusiveEarningMask";
import { jumpToAppStore } from "@/utils/tenjin";
import Danmaku from "./_components/Danmaku";
import {
  YOO_FINDS_LOGO,
  DL_MAJOR_DEBUT,
  DL_RECOM_PHO,
  DL_ARROW,
  DL_BK,
  DL_MAN,
  DL_PEOPLE,
  DL_RIGHT_STAR,
  DL_Y,
} from "@/cdn";
import { isMobile } from "@/utils/is";
// import useInviterInfo from "@/hooks/useInviterInfo";
import "./index.scss";

const classPrefix = "yfm-download-page";

const BK = {
  background: `url("${DL_BK}")`,
  backgroundSize: "100% 100%",
};

const arrowText = [
  "Low brand response？",
  "High brand standards, cant apply good samples?",
  "Hard to choose the right product?",
  "Low expected returns?",
  "How to make good contents?",
];

const danmuTextFirstArray = [
  "Fast Samples Request",
  "Low Samples Threshold",
  "Fast Samples Request",
  "Low Samples Threshold",
];

const danmuTextSecondArray = [
  "Exclusive high commission products",
  "Fulfillment support",
  "Exclusive high commission products",
  "Fulfillment support",
];

const danmuTextThirdArray = [
  "Unlimited samples",
  "Explore limitless possibilities",
  "Unlimited samples",
  "Explore limitless possibilities",
];

const DownloadPageContent: FC = () => {
  const [showExclusiveEarningMask, setShowExclusiveEarningMask] =
    useState(false);
  // 使用状态来控制移动端判断，避免水合错误
  const [isMobileDevice, setIsMobileDevice] = useState(false);
  const [isMounted, setIsMounted] = useState(false);

  // 目前一级合伙人暂时不需要了，如果以后需要可以通过下面拿邀请者信息
  // const { inviterInfo, isReady } = useInviterInfo();

  // 在客户端挂载后设置移动端状态
  useEffect(() => {
    setIsMounted(true);
    const mobile = isMobile() ?? false;
    setIsMobileDevice(mobile);
    if (!mobile) {
      setShowExclusiveEarningMask(true);
    }
  }, []);

  const handleDownload = () => {
    if (isMobileDevice) {
      jumpToAppStore();
    } else {
      setShowExclusiveEarningMask(true);
    }
  };

  useEffect(() => {
    if (showExclusiveEarningMask) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [showExclusiveEarningMask]);

  return (
    <div className={classPrefix}>
      {/* <pre>{JSON.stringify(inviterInfo, null, 2)}</pre> */}
      {/* <pre>{JSON.stringify(isReady)}</pre> */}
      <div className={`${classPrefix}__container`}>
        <div className={`${classPrefix}__flex-box`}>
          <div className={`${classPrefix}__hero`}>
            <Image
              width={0}
              height={0}
              src={YOO_FINDS_LOGO}
              className={`${classPrefix}__logo`}
              alt=""
            />
            <div>
              <Image
                className={`${classPrefix}__major-db`}
                width={0}
                height={0}
                src={DL_MAJOR_DEBUT}
                alt=""
              />
              <div className={`${classPrefix}__circle-left`}></div>
              <Image
                className={`${classPrefix}__recom-ph`}
                width={0}
                height={0}
                src={DL_RECOM_PHO}
                alt=""
              />
              <div className={`${classPrefix}__circle-right`}></div>
            </div>
          </div>
        </div>

        <div className={`${classPrefix}__flex-box`}>
          <div className={`${classPrefix}__cont`}>
            <div className={`${classPrefix}__left-num`}>01</div>
            <Image
              className={`${classPrefix}__right-star`}
              width={0}
              height={0}
              src={DL_RIGHT_STAR}
              alt=""
            />
            <div className={`${classPrefix}__bk`} style={BK}></div>
            <div className={`${classPrefix}__bk-bottom`}></div>
            <div className={`${classPrefix}__title`}>Your pain points</div>
            <ul className={`${classPrefix}__pain-list`}>
              {arrowText.map((item, index) => (
                <li className={`${classPrefix}__pain-item`} key={index}>
                  <Image
                    className={`${classPrefix}__arrow`}
                    width={0}
                    height={0}
                    src={DL_ARROW}
                    alt=""
                  />
                  <span className={`${classPrefix}__content`}>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className={`${classPrefix}__flex-box`}>
          <div className={`${classPrefix}__middle-cont`}>
            <span className={`${classPrefix}__cont1`}>DON&apos;T WORRY!</span>
            <span className={`${classPrefix}__cont2`}>
              we&apos;re here to solve your needs
            </span>
          </div>
        </div>

        <div className={`${classPrefix}__flex-box`}>
          <div
            className={cs(`${classPrefix}__cont`, `${classPrefix}__cont--b`)}
          >
            <div className={`${classPrefix}__left-num`}>02</div>
            <Image
              className={`${classPrefix}__right-star`}
              width={0}
              height={0}
              src={DL_RIGHT_STAR}
              alt=""
            />
            <div className={`${classPrefix}__bk`} style={BK}></div>
            <div
              className={cs(
                `${classPrefix}__bk-bottom`,
                `${classPrefix}__bk-bottom--b`
              )}
            ></div>
            <div className={`${classPrefix}__title`}>Introduction</div>
            <span className={`${classPrefix}__intro`}>
              YooFinds, Tiktok Creators&apos; personal assistant, provide
              exclusive high-commission best-selling products, a large selection
              of free samples, and more opportunities to earn money through
              video charting, live broadcast charting, and advertising tasks.
            </span>
          </div>
        </div>

        <div className={`${classPrefix}__flex-box`}>
          <div className={`${classPrefix}__creator-get`}>
            <div className={`${classPrefix}__bg`}>
              <Image
                className={`${classPrefix}__man`}
                width={0}
                height={0}
                src={DL_MAN}
                alt=""
              />
            </div>

            <div className={`${classPrefix}__get`}>
              Creators will get:{" "}
              <Image
                className={`${classPrefix}__people`}
                width={0}
                height={0}
                src={DL_PEOPLE}
                alt=""
              />
            </div>
          </div>
        </div>

        <Danmaku
          danmakuText={danmuTextFirstArray}
          danmakuIcon={DL_Y}
          danmakuType={1}
        />
        <Danmaku
          danmakuText={danmuTextSecondArray}
          danmakuIcon={DL_Y}
          danmakuType={2}
        />
        <Danmaku
          danmakuText={danmuTextThirdArray}
          danmakuIcon={DL_Y}
          danmakuType={3}
        />

        <div className={`${classPrefix}__flex-box`}>
          <div className={`${classPrefix}__text1`}>
            Join us for video and live ranking competition to win rewards of{" "}
            <span className={`${classPrefix}__number`}>$30,000</span>
            <span className={`${classPrefix}__last`}>! </span>
          </div>
        </div>

        {/* {inviterInfo.is_agency_code && (
          <div className={`${classPrefix}__flex-box`}>
            <div className={`${classPrefix}__text2`}>
              Enjoy exclusive high commissions and unlimited sample access,
              helping you stand out in the industry!
            </div>
          </div>
        )} */}
      </div>

      <div className={`${classPrefix}__bottom-wrapper`}>
        <div className={`${classPrefix}__bottom-inner`}>
          <div className={`${classPrefix}__bottom-box yfm-app-page-width-fix`}>
            <Button
              className={`${classPrefix}__download-btn`}
              // loading={!isReady}
              onClick={handleDownload}
            >
              <div className={`${classPrefix}__btn-inner`}>
                <span>Download</span>
              </div>
            </Button>
          </div>
        </div>
      </div>

      {showExclusiveEarningMask && (
        <ExclusiveEarningMask
          onClose={() => setShowExclusiveEarningMask(false)}
        />
      )}

      {isMounted && !isMobileDevice && (
        <div
          className={`${classPrefix}__qr-code`}
          onClick={() => setShowExclusiveEarningMask(true)}
        >
          <SystemQRcodeOutline
            className={`${classPrefix}__qr-code-icon`}
            color="#25f4ee"
          />
        </div>
      )}
    </div>
  );
};

export default DownloadPageContent;
